<div class="relative">
  <div class="w-full bg-white shadow-sm relative">

    <!-- Loading -->
    <div *ngIf="isLoading"
      class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-white opacity-75 flex flex-col items-center justify-center">
      <div class="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-indigo-500"></div>
    </div>

    <!-- Error Card -->
    <div *ngIf="showErrorCard" class="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50"
      (click)="closeErrorCard()">
      <div class="bg-white rounded-lg shadow-xl p-6 max-w-sm w-full relative" (click)="$event.stopPropagation()">
        <button (click)="closeErrorCard()" class="absolute top-2 right-2 text-gray-400 hover:text-gray-600">
          <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <div class="text-center">
          <svg class="mx-auto h-12 w-12 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <h3 class="mt-2 text-lg font-medium text-gray-900">{{ errorTitle }}</h3>
          <p class="mt-1 text-sm text-gray-500">{{ errorMessage }}</p>
        </div>
      </div>
    </div>

    <section class="border-collapse pb-3 mt-2 h-full bg-white shadow-sm">
      <!-- Stale filters banner -->
      <div *ngIf="filtersChanged"
        class="flex items-center gap-2 px-4 py-2 bg-amber-50 border-b border-amber-200 text-amber-800 regular-font text-sm">
        <svg class="w-4 h-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
        </svg>
        Filters have changed. Click <strong class="mx-1">Run Report</strong> to refresh the results.
      </div>

      <!-- Filter Bar -->
      <div class="flex w-full items-end flex-wrap gap-x-4 gap-y-3 px-4 py-3 bg-white border-b border-gray-200">

        <!-- PMS Filter -->
        <div class="flex flex-col gap-1" (click)="$event.stopPropagation()">
          <span class="text-xs font-medium text-gray-500 uppercase tracking-wide">PMS</span>
          <div class="relative">
            <button type="button"
              class="inline-flex justify-between w-52 border border-gray-300 rounded shadow-sm px-3 py-1.5 bg-white regular-font text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              (click)="isPmsDropdownOpen = !isPmsDropdownOpen">
              <span class="truncate">{{ pmsFilterLabel }}</span>
              <svg class="ml-2 h-5 w-5 text-gray-400 shrink-0" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                  d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                  clip-rule="evenodd" />
              </svg>
            </button>
            <div *ngIf="isPmsDropdownOpen"
              class="absolute left-0 z-20 mt-1 w-52 bg-white border border-gray-200 rounded shadow-lg">
              <div class="px-2 pt-2 pb-1">
                <input type="text" [(ngModel)]="pmsSearch" placeholder="Search PMS..."
                  class="w-full border border-gray-300 rounded px-2 py-1 text-sm regular-font focus:outline-none focus:ring-1 focus:ring-indigo-500" />
              </div>
              <div class="max-h-52 overflow-auto">
                <div class="py-1 px-3" *ngFor="let pms of filteredPmsList">
                  <label class="inline-flex items-center gap-2 cursor-pointer py-0.5">
                    <input type="checkbox" class="form-checkbox h-4 w-4 text-indigo-600 rounded"
                      [checked]="isPmsSelected(pms.id)" (change)="togglePms(pms)" />
                    <span class="regular-font text-gray-700 whitespace-nowrap">{{ pms.name }}</span>
                  </label>
                </div>
                <div *ngIf="filteredPmsList.length === 0" class="px-3 py-2 text-sm text-gray-400 regular-font">No
                  results</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Practice Filter -->
        <div class="flex flex-col gap-1" (click)="$event.stopPropagation()">
          <span class="text-xs font-medium text-gray-500 uppercase tracking-wide">Practice</span>
          <div class="relative">
            <button type="button"
              class="inline-flex justify-between w-52 border border-gray-300 rounded shadow-sm px-3 py-1.5 bg-white regular-font text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              (click)="isPracticeDropdownOpen = !isPracticeDropdownOpen">
              <span class="truncate">{{ practiceFilterLabel }}</span>
              <svg class="ml-2 h-5 w-5 text-gray-400 shrink-0" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                  d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                  clip-rule="evenodd" />
              </svg>
            </button>
            <div *ngIf="isPracticeDropdownOpen"
              class="absolute left-0 z-20 mt-1 w-52 bg-white border border-gray-200 rounded shadow-lg">
              <div class="px-2 pt-2 pb-1">
                <input type="text" [(ngModel)]="practiceSearch" placeholder="Search practice..."
                  class="w-full border border-gray-300 rounded px-2 py-1 text-sm regular-font focus:outline-none focus:ring-1 focus:ring-indigo-500" />
              </div>
              <div class="max-h-52 overflow-auto">
                <div class="py-1 px-3" *ngFor="let p of practiceOptions">
                  <label class="inline-flex items-center gap-2 cursor-pointer py-0.5">
                    <input type="checkbox" class="form-checkbox h-4 w-4 text-indigo-600 rounded"
                      [checked]="isPracticeSelected(p.id)" (change)="togglePractice(p)" />
                    <span class="regular-font text-gray-700 whitespace-nowrap">{{ p.name }}</span>
                  </label>
                </div>
                <div *ngIf="practiceOptions.length === 0" class="px-3 py-2 text-sm text-gray-400 regular-font">No
                  results</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Date Range -->
        <div class="flex flex-col gap-1">
          <span class="text-xs font-medium text-gray-500 uppercase tracking-wide">Date Range</span>
          <div class="flex items-center gap-2">
            <input type="date" [(ngModel)]="startDate" [max]="endDate" (change)="markFiltersChanged()"
              class="form-input regular-font border border-gray-300 rounded shadow-sm px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-indigo-500" />
            <span class="text-gray-400 text-sm">—</span>
            <input type="date" [(ngModel)]="endDate" [min]="startDate" (change)="markFiltersChanged()"
              class="form-input regular-font border border-gray-300 rounded shadow-sm px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-indigo-500" />
          </div>
        </div>

        <!-- Report Format -->
        <div class="flex flex-col gap-1">
          <span class="text-xs font-medium text-gray-500 uppercase tracking-wide">Report Format</span>
          <div class="flex gap-3">
            <label *ngFor="let fmt of FORMAT_OPTIONS" class="inline-flex items-center gap-1.5 cursor-pointer">
              <input type="radio" name="reportFormat" [value]="fmt.value" [(ngModel)]="reportFormat"
                (change)="markFiltersChanged()" class="text-indigo-600" />
              <span class="regular-font text-gray-700">{{ fmt.label }}</span>
            </label>
          </div>
        </div>

        <!-- Actions -->
        <div class="flex items-center gap-2 ml-auto">
          <button (click)="resetFilters()"
            class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded border border-gray-300 bg-indigo-600 text-white regular-font hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm">
            <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
            Reset
          </button>
          <button (click)="fetchReport()"
            class="inline-flex items-center gap-1.5 px-4 py-1.5 rounded bg-indigo-600 text-white regular-font hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm">
            <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M14.752 11.168l-4.586-2.65A1 1 0 009 9.38v5.24a1 1 0 001.166.986l4.586-2.65a1 1 0 000-1.788z" />
              <path stroke-linecap="round" stroke-linejoin="round" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Run Report
          </button>
          <div class="relative" (click)="$event.stopPropagation()">
            <button (click)="isDropdownOpen = !isDropdownOpen"
              class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded border border-gray-300 bg-indigo-600 text-white regular-font hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm">
              <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
              </svg>
              Export
            </button>
            <div *ngIf="isDropdownOpen"
              class="absolute right-0 mt-1 w-52 bg-white border border-gray-200 rounded shadow-lg z-10">
              <a class="block px-4 py-2 regular-font text-gray-700 hover:bg-gray-100 cursor-pointer"
                (click)="exportToExcel()">Export Current Data To Excel</a>
              <div class="border-t border-gray-200"></div>
              <a class="block px-4 py-2 regular-font text-gray-700 hover:bg-gray-100 cursor-pointer"
                (click)="exportAllToExcel()">Export All Data To Excel</a>
              <div class="border-t border-gray-200"></div>
              <a class="block px-4 py-2 regular-font text-gray-700 hover:bg-gray-100 cursor-pointer"
                (click)="exportDataToPDF()">Export Current Data To PDF</a>
              <div class="border-t border-gray-200"></div>
              <a class="block px-4 py-2 regular-font text-gray-700 hover:bg-gray-100 cursor-pointer"
                (click)="exportAllDataToPDF()">Export All Data To PDF</a>
            </div>
          </div>
        </div>
      </div>

      <!-- Table -->
      <section class="overflow-auto h-[calc(100vh-310px)]">
        <div *ngIf="dataSource.data.length === 0 && !isLoading"
          class="flex items-center justify-center h-48 text-gray-500 regular-font">
          {{ reportRan ? 'No data found.' : 'Run the report to see results.' }}
        </div>
        <table *ngIf="dataSource.data.length > 0" mat-table [dataSource]="dataSource" matSort
          class="mat-elevation-z8 w-full">

          <ng-container matColumnDef="practiceCode">
            <th mat-header-cell *matHeaderCellDef 
              class="sticky top-0 regular-font text-gray-700 uppercase !bg-violet-100 whitespace-nowrap border-r border-gray-200">
              Practice Code
            </th>
            <td mat-cell *matCellDef="let row" class="regular-font border-r border-gray-200 whitespace-nowrap">
              {{ row.practiceCode }}
            </td>
          </ng-container>

          <ng-container matColumnDef="groupKey">
            <th mat-header-cell *matHeaderCellDef 
              class="sticky top-0 regular-font text-gray-700 uppercase !bg-violet-100 whitespace-nowrap border-r border-gray-200">
              {{ groupKeyLabel }}
            </th>
            <td mat-cell *matCellDef="let row" class="regular-font border-r border-gray-200 whitespace-nowrap">
              {{ row.groupKey }}
            </td>
          </ng-container>

          <ng-container matColumnDef="amountProduction">
            <th mat-header-cell *matHeaderCellDef 
              class="sticky top-0 regular-font text-gray-700 uppercase !bg-violet-100 whitespace-nowrap border-r border-gray-200">
              Production Amount
            </th>
            <td mat-cell *matCellDef="let row" class="regular-font border-r border-gray-200 text-right">
              {{ formatCurrency(row.amountProduction) }}
            </td>
          </ng-container>

          <ng-container matColumnDef="amountAdjustment">
            <th mat-header-cell *matHeaderCellDef 
              class="sticky top-0 regular-font text-gray-700 uppercase !bg-violet-100 whitespace-nowrap border-r border-gray-200">
              Adjustment Amount
            </th>
            <td mat-cell *matCellDef="let row" class="regular-font border-r border-gray-200 text-right"
              [ngClass]="{'text-red-600': row.amountAdjustment < 0}">
              {{ formatCurrency(row.amountAdjustment) }}
            </td>
          </ng-container>

          <ng-container matColumnDef="netAmount">
            <th mat-header-cell *matHeaderCellDef 
              class="sticky top-0 regular-font text-gray-700 uppercase !bg-violet-100 whitespace-nowrap border-r border-gray-200">
              Net Amount
            </th>
            <td mat-cell *matCellDef="let row" class="regular-font border-r border-gray-200 text-right font-semibold"
              [ngClass]="{'text-green-700': row.netAmount >= 0, 'text-red-600': row.netAmount < 0}">
              {{ formatCurrency(row.netAmount) }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-gray-50 z-20"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"
            class="hover:bg-slate-100 border-b border-gray-200"></tr>
        </table>
      </section>

      <!-- Pagination -->
      <div class="px-5 py-2 overflow-hidden" [class.hidden]="totalRecords === 0">
        <mat-paginator class="custom-paginator regular-font" style="font-size: 12px !important" [length]="totalRecords"
          [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons>
        </mat-paginator>
      </div>
    </section>
  </div>
  <app-toast></app-toast>
</div>
<router-outlet></router-outlet>